<template>
	<div class="wrapper-template-faces" :style="`border-color:${$appColors.primary}`">
		<div
			class="faces-container"
			v-for="(answer, index) in answers"
			:key="index"
		>
			<div
				class="faces-wrapper"
				:style="`border-color:${answersSelected === answer.id ? $appColors.success : $appColors.secondary}`"
				:class="{ 'faces-wrapper-active': answersSelected === answer.id }"
				@click="selectAnswer(answer)"
			>
				<img
					:src="answer.urlImage.web"
					alt="icónos de estados"
					:class="{ 'face-not-selected': answersSelected !== answer.id }"
				>
			</div>
			<span
				:class="{ 'faces-text-active': answersSelected === answer.id }"
				:style="`color:${answersSelected === answer.id ? $appColors.success : $appColors.gray}`"
			>{{answer.name}}</span>
		</div>
		<div class="header-template-faces"
			:style="`background-color:${$appColors.primary}`"
		>
			<div
				class="header-text"
				v-for="(answer, i) in answers"
				:key="i"
			>{{answer.name}}</div>
		</div>
	</div>
</template>
<script>
function selectAnswer({ id }) {
	this.$emit('selected-icon', id);
	if (!this.answersSelected) {
		this.$store.commit('UPDATE_POLL_PROGRESS', 1);
	}
	this.answersSelected = id;
}

function data() {
	return {
		answersSelected: 0,
	};
}

export default {
	name: 'faces-template',
	data,
	methods: {
		selectAnswer,
	},
	props: {
		answers: {
			default: () => [],
			type: Array,
		},
	},
};
</script>
<style lang="scss" scoped>
	.wrapper-template-faces {
		@include flex-space-between;
		background-color: #ffffff;
		border: 1px solid;
		border-radius: 7px;
		cursor: pointer;
		font-family: font(bold);
		font-size: 14px;
		margin: 0 auto;
		min-width: 360px;
		padding: 30px 20px;
		position: relative;

		@media (max-width: 500px) {
			border: none;
			box-sizing: border-box;
			padding: 40px 20px 0;
			min-width: 100%;
		}
	}

	.faces-container {
		@include flex-center;
		flex-direction: column;
		margin: 0 11px;

		@media (max-width: 500px) {
			margin: 0;
		}
	}

	.faces-wrapper {
		@include flex-center;
		border: 3px solid;
		border-radius: 50%;
		height: 56px;
		opacity: 0.2;
		width: 56px;

		img {
			height: 36px;
			width: 36px;
		}
	}

	.faces-wrapper-active {
		border: 3px solid;
		opacity: 1;

	}

	span {

		@media (max-width: 500px) {
			display: none;
		}
	}

	.face-not-selected {
		filter: brightness(0);
		opacity: 0.8;
	}

	.header-template-faces {
		display: none;

		@media (max-width: 500px) {
			@include flex-space-between;
			color: color(white);
			left: 0;
			margin-bottom: 5px;
			padding: 5px 10px;
			position: absolute;
			top: 0;
			width: 100%;
		}
	}

	.header-text {

		@media (max-width: 500px) {
			text-transform: uppercase;
		}
	}
</style>




// WEBPACK FOOTER //
// src/components/polls/faces-template.vue